import React, { useState, useEffect, useContext } from "react";
import Application from "../../../StateContext/Application";
import { use } from "react";
import { apiurl } from "../../../../../path";
import "./billfiles.css"
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext";
const BillFiles = (props) => {
    const { language, toggleLanguage, t } = useLanguage();
  const statecalls = useContext(Application);
  const { GetBillFiles } = statecalls;
  const [refundfiles, setRefundFiles] = useState([]);
  const [refunddata, setRefundData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  useEffect(() => {
    GetAllBillFiles();
  }, [])

  const totalPages = Math.ceil(refundfiles.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = refundfiles.slice(indexOfFirstBill, indexOfLastBill);

  async function GetAllBillFiles() {
    try {
      let data = await GetBillFiles();
      const sortedData = data.sort((a, b) =>
        new Date(a.Date) - new Date(b.Date)
      );
      setRefundFiles(sortedData);
      console.log("refundfiles",refundfiles)
    } catch (error) {
      console.error(error)
    }
  }

  // return (
  //   <>

  //     {
  //       false &&
  //       <div style={{ display: 'flex', justifyContent: 'center', padding: "55px 20px", overflow: "auto", backgroundColor: '#f4f7fe', maxHeight: '94vh' }}>
  //         <div style={{ display: "grid", justifyContent: "center", boxShadow: "0px 0px 10px", borderRadius: "20px", width: "75vw", maxWidth: "100%", }}>
  //           <div style={{ overflowX: "auto", width: "100%", borderRadius: "20px", }}>
  //             <table style={{ backgroundColor: "white", width: "100%", borderRadius: "20px", overflow: "hidden", borderCollapse: "collapse", minWidth: "78vw", }}>
  //               <thead style={{ borderTop: "none" }}>
  //                 <tr style={{ backgroundColor: "#c3c4c7", color: "black", border: "none", borderRadius: "10px", overflow: "hidden", height: "3rem", fontSize: "16px", textAlign: "center", }}>
  //                   <th>Sr.no.</th>
  //                   <th>File Name</th>
  //                   <th>Upload Date</th>
  //                   <th>Bill Processed by</th>
  //                 </tr>
  //               </thead>
  //               <tbody>
  //                 {currentBills?.length === 0 ? (
  //                   <tr>
  //                     <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
  //                       No data available
  //                     </td>
  //                   </tr>
  //                 ) : (
  //                   currentBills && currentBills.map((e, index) => {
  //                     return (
  //                       <tr key={index}>
  //                         <td><img src="" />{index + 1}</td>
  //                         <td style={{ height: '2rem' }}><a href={`${apiurl}/UploadedBillsFiles/${e.FileName}`} target='_blank'>{e.FileName}</a></td>
  //                         <td>{new Date(e.CreatedOn).toLocaleString('en-GB', {
  //                           year: 'numeric',
  //                           month: '2-digit',
  //                           day: '2-digit',
  //                           hour: '2-digit',
  //                           minute: '2-digit',
  //                           second: '2-digit',
  //                           hour12: false
  //                         }).replace(',', '')}</td>
  //                         <td>{e.CreatedBy}</td>
  //                       </tr>
  //                     );
  //                   })
  //                 )}
  //               </tbody>
  //             </table>
  //           </div>
  //           <div style={{ display: 'flex', justifyContent: 'space-evenly', margin: '10px 0' }}>
  //             <button
  //               onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
  //               disabled={currentPage === 1}
  //               style={{ padding: '8px 15px', borderRadius: '5px', cursor: 'pointer', backgroundColor: currentPage === 1 ? '#ccc' : 'blue', color: 'white' }}
  //             >
  //               Previous
  //             </button>
  //             <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
  //               Page {currentPage} of {totalPages}
  //             </span>
  //             <button
  //               onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
  //               disabled={currentPage === totalPages}
  //               style={{ padding: '6px 15px', borderRadius: '5px', cursor: 'pointer', backgroundColor: currentPage === totalPages ? '#ccc' : 'blue', color: 'white' }}
  //             >
  //               Next
  //             </button>
  //           </div>
  //         </div>
  //       </div>
  //     }

  //     <div className="col-12">
  //       <div className="billfileContainer">

  //         <div className="col-11 m-auto my-3">
  //           <h4 className="fw-bold">Bill Files</h4>
  //         </div>


  //         <div className="billtableContainer m-auto">
  //           <div className="tableContainer py-0">
  //             <table className="col-12 my-0 m-auto">
  //               <thead>
  //                 <tr>
  //                   <th style={{ width: "10%" }}>Sr No</th>
  //                   <th style={{ width: "40%" }}>File Name</th>
  //                   <th style={{ width: "30%" }}>Upload Date</th>
  //                   <th style={{ width: "20%" }}>Bill processed by</th>
  //                 </tr>
  //               </thead>
  //               <tbody>
  //                 {currentBills?.length === 0 ? (
  //                   <tr>
  //                     <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
  //                       No data available
  //                     </td>
  //                   </tr>
  //                 ) : (
  //                   currentBills && currentBills.map((e, index) => {
  //                     return (
  //                       <tr key={index} style={{ backgroundColor: index % 2 == 0 ? "#E4ECF6" : "#D1E0F3" }}>
  //                         <td><img src="" />{(currentPage - 1) * billsPerPage + index + 1}</td>
  //                         <td className="fw-bold text-start ps-3" style={{ color: "#2C78BC" }}>
  //                           <img className="me-1 my-auto" src="/txt32.png" alt="" style={{ width: "20px", height: "20px" }} />
  //                           <a href={`${apiurl}/UploadedBillsFiles/${e.FileName}`} target='_blank'>{e.FileName}</a></td>
  //                         <td className="fw-bold " style={{ color: "#2C78BC" }}>
  //                           <img className="me-1 my-auto" src="/Time32.png" alt=""
  //                             style={{ width: "18px", height: "18px", filter: "invert(16%) sepia(97%) saturate(7489%) hue-rotate(250deg) brightness(101%) contrast(105%)" }} />
  //                           {new Date(e.CreatedOn).toLocaleString()}</td>
  //                         <td className="fw-bold">{e.CreatedBy}</td>
  //                       </tr>
  //                     );
  //                   })
  //                 )}
  //               </tbody>
  //             </table>
  //           </div>


  //           <div style={{ width: '100%' }} className="m-auto my-3">
  //             <div className="row">

  //               <div className="col-6">
  //                 <p className="text-gray-600" style={{ fontSize: "14px" }}>Showing {currentBills.length > 0 ? indexOfFirstBill + 1 : 0} to {Math.min(indexOfLastBill, refundfiles.length)} of {refundfiles?.length} entries</p>
  //               </div>

  //               <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
  //                 {/* First Page Button */}
  //                 <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
  //                   style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>
  //                   &laquo;
  //                 </button>
  //                 {/* Previous Button */}
  //                 <button
  //                   onClick={() => setCurrentPage(currentPage - 1)}
  //                   disabled={currentPage === 1}
  //                   style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
  //                   &lt;
  //                 </button>

  //                 <button
  //                   style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
  //                 </button>
  //                 {/* Next Button */}
  //                 <button
  //                   onClick={() => setCurrentPage(currentPage + 1)}
  //                   disabled={currentPage === totalPages}
  //                   style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
  //                   &gt;
  //                 </button>
  //                 {/* Last Page Button */}
  //                 <button
  //                   onClick={() => setCurrentPage(totalPages)}
  //                   disabled={currentPage === totalPages}
  //                   style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
  //                   &raquo;
  //                 </button>
  //               </div>

  //             </div>

  //           </div>
  //         </div>


  //       </div>
  //     </div>




  //   </>
  // );
 return (
    <>

      {
        false &&
        <div style={{ display: 'flex', justifyContent: 'center', padding: "55px 20px", overflow: "auto", backgroundColor: '#f4f7fe', maxHeight: '94vh' }}>
          <div style={{ display: "grid", justifyContent: "center", boxShadow: "0px 0px 10px", borderRadius: "20px", width: "75vw", maxWidth: "100%", }}>
            <div style={{ overflowX: "auto", width: "100%", borderRadius: "20px", }}>
              <table style={{ backgroundColor: "white", width: "100%", borderRadius: "20px", overflow: "hidden", borderCollapse: "collapse", minWidth: "78vw", }}>
                <thead style={{ borderTop: "none" }}>
                  <tr style={{ backgroundColor: "#c3c4c7", color: "black", border: "none", borderRadius: "10px", overflow: "hidden", height: "3rem", fontSize: "16px", textAlign: "center", }}>
                    <th>{t("Sr.no.")}</th>
                    <th>{t("File Name")}</th>
                    <th>{t("Upload Date")}</th>
                    <th>{t("Bill Processed by")}</th>
                  </tr>
                </thead>
                <tbody>
                  {currentBills?.length === 0 ? (
                    <tr>
                      <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                        {t("No data available")}
                      </td>
                    </tr>
                  ) : (
                    currentBills && currentBills.map((e, index) => {
                      return (
                        <tr key={index}>
                          <td><img src="" />{index + 1}</td>
                          <td style={{ height: '2rem' }}><a href={`${apiurl}/UploadedBillsFiles/${e.FileName}`} target='_blank'>{e.FileName}</a></td>
                          <td>{new Date(e.CreatedOn).toLocaleString('en-GB', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                            second: '2-digit',
                            hour12: false
                          }).replace(',', '')}</td>
                          <td>{e.CreatedBy}</td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-evenly', margin: '10px 0' }}>
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                style={{ padding: '8px 15px', borderRadius: '5px', cursor: 'pointer', backgroundColor: currentPage === 1 ? '#ccc' : 'blue', color: 'white' }}
              >
                {t("Previous")}
              </button>
              <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
               {t(" Page")} {currentPage} {t("of")} {totalPages}
              </span>
              <button
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                style={{ padding: '6px 15px', borderRadius: '5px', cursor: 'pointer', backgroundColor: currentPage === totalPages ? '#ccc' : 'blue', color: 'white' }}
              >
                {t("Next")}
              </button>
            </div>
          </div>
        </div>
      }

      <div className="col-12">
        <div className="billfileContainer">

          <div className="col-11 m-auto my-3">
            <h4 className="fw-bold">{t("Bill Files")}</h4>
          </div>


          <div className="billtableContainer m-auto">
            <div className="tableContainer py-0">
              <table className="col-12 my-0 m-auto">
                <thead>
                  <tr>
                    <th style={{ width: "10%" }}>{t("Sr No")}</th>
                    <th style={{ width: "40%" }}>{t("File Name")}</th>
                    <th style={{ width: "30%" }}>{t("Upload Date")}</th>
                    <th style={{ width: "20%" }}>{t("Bill processed by")}</th>
                  </tr>
                </thead>
                <tbody>
                  {currentBills?.length === 0 ? (
                    <tr>
                      <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                        {t("No data available")}
                      </td>
                    </tr>
                  ) : (
                    currentBills && currentBills.map((e, index) => {
                      return (
                        <tr key={index} style={{ backgroundColor: index % 2 == 0 ? "#E4ECF6" : "#D1E0F3" }}>
                          <td><img src="" />{(currentPage - 1) * billsPerPage + index + 1}</td>
                          <td className="fw-bold text-start ps-3" style={{ color: "#2C78BC" }}>
                            <img className="me-1 my-auto" src="/txt32.png" alt="" style={{ width: "20px", height: "20px" }} />
                            <a href={`${apiurl}/UploadedBillsFiles/${e.FileName}`} target='_blank'>{e.FileName}</a></td>
                          <td className="fw-bold " style={{ color: "#2C78BC" }}>
                            <img className="me-1 my-auto" src="/Time32.png" alt=""
                              style={{ width: "18px", height: "18px", filter: "invert(16%) sepia(97%) saturate(7489%) hue-rotate(250deg) brightness(101%) contrast(105%)" }} />
                            {new Date(e.CreatedOn).toLocaleString()}</td>
                          <td className="fw-bold">{e.CreatedBy}</td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>


            <div style={{ width: '100%' }} className="m-auto my-3">
              <div className="row">

                <div className="col-6">
                  <p className="text-gray-600" style={{ fontSize: "14px" }}>{t("Showing")} {currentBills.length > 0 ? indexOfFirstBill + 1 : 0} {t("to")} {Math.min(indexOfLastBill, refundfiles.length)} {t("of")} {refundfiles?.length} {t("entries")}</p>
                </div>

                <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
                  {/* First Page Button */}
                  <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                    style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>
                    &laquo;
                  </button>
                  {/* Previous Button */}
                  <button
                    onClick={() => setCurrentPage(currentPage - 1)}
                    disabled={currentPage === 1}
                    style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                    &lt;
                  </button>

                  <button
                    style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                  </button>
                  {/* Next Button */}
                  <button
                    onClick={() => setCurrentPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                    &gt;
                  </button>
                  {/* Last Page Button */}
                  <button
                    onClick={() => setCurrentPage(totalPages)}
                    disabled={currentPage === totalPages}
                    style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                    &raquo;
                  </button>
                </div>

              </div>

            </div>
          </div>


        </div>
      </div>




    </>
  );
};


export default BillFiles;
